<template>
  <v-select
    ref="controlFocoSelectModulo"
    label="Módulo*"
    v-model="iModel"
    :items="items"
    item-value="Id_Modulo"
    item-text="Nombre"
    :rules="rules"
    :readonly="readonly"
    :loading="loadingActivo"
  >
    <template v-slot:no-data
      >No hay datos para mostrar</template
    >
    <template v-slot:progress>
      <v-progress-circular color="blue" indeterminate></v-progress-circular>
    </template>
  </v-select>
</template>

<script>
import HttpHelper from "@/store/HttpHelper";
import { eventBus } from "@/main";
export default {
  name: "SelectModulo",
  props: {
    model: Number,
    rules: {},
    readonly: Boolean
  },
  data() {
    return {
      items: [],
      loadingActivo: false
    };
  },
  computed: {
    iModel: {
      get() {
        return this.model;
      },
      set(valor) {
        if (valor != undefined && valor != 0) {
          var ind = this.items.findIndex(x => x.Id_Modulo == valor);
          this.$emit("seleccionarItem", this.items[ind]);
        }
      }
    }
  },
  created() {
    eventBus.$on("setearFocoSelectModulo", this.setearFoco);
    this.inicializar();
  },
  beforeDestroy() {
    eventBus.$off("setearFocoSelectModulo", this.setearFoco);
  },
  methods: {
    inicializar() {
      this.items = [];
      this.listarItems();
    },
    listarItems() {
      this.loadingActivo = true;
      HttpHelper.get("Modulo", {
        palabra: ""
      })
        .then(response => {
          this.items = response.data;
          if (this.items.length > 0) this.iModel = this.items[0].Id_Modulo;
          this.loadingActivo = false;
        })
        .catch(error => {
          return Promise.reject(error);
        });
    },
    setearFoco() {
      this.$refs.controlFocoSelectModulo.focus();
    }
  }
};
</script>
